import {
  Component,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';

/**
  Componente que proporciona funcionalidad de desplazamiento (scroll) personalizable.
  Este componente permite desplazar contenido dentro de un contenedor con controles personalizados
  y emite eventos cuando se realiza un desplazamiento.
**/
@Component({
  selector: 'app-am-scroll',
  templateUrl: './am-scroll.component.html',
  styleUrls: ['./am-scroll.component.scss'],
  standalone: false
})
export class AmScrollComponent implements AfterViewInit {

  /**
    Altura del contenedor de desplazamiento.
    @type {number}
    @default 270
  **/
    @Input() height: number = 270;
    @Input() isMandatoryHeight = false;
    @Input() scrollAmount = 100;
    /**
      Velocidad de desplazamiento al usar la rueda del mouse o los controles.
      @type {number}
      @default 1
    **/
    @Input() scrollSpeed: number = 1;

    /**
      Indica si se debe forzar la visualización de la barra de desplazamiento, incluso si el contenido no lo requiere.
      @type {boolean}
      @default false
    **/
    @Input() forceScroll: boolean = false;

    /**
      Espaciado derecho aplicado al contenedor de desplazamiento.
      @type {number}
      @default 20
    **/
    @Input() paddingRight: number = 20;

    /**
      Evento que se emite cuando se realiza un desplazamiento.
      @type {EventEmitter<number>}
    **/
    @Output() scrolled = new EventEmitter<number>();

    /**
      Indica si el tema del scroll seria en blanco.
      @type {boolean}
    **/
    @Input() themeLightScroll: boolean = false;

    /**
      Referencia al contenedor de desplazamiento en el DOM.
      @type {ElementRef}
    **/
    @ViewChild('scrollContainer') scrollContainer!: ElementRef;

    /**
      Indica si se debe mostrar la barra de desplazamiento.
      @type {boolean}
    **/
    showScroll: boolean = false;

    /**
      Indica si se debe mostrar el plano de desplazamiento.
      @type {boolean}
    **/
    showScrollPlane: boolean = false;

    /**
      Indica si el botón de desplazamiento hacia arriba está activo.
      @type {boolean}
    **/
    activeUp: boolean = false;

    /**
      Indica si el botón de desplazamiento hacia abajo está activo.
      @type {boolean}
    **/
    activeDown: boolean = false;

    /**
      Ancho del margen izquierdo calculado para el contenedor de desplazamiento.
      @type {number}
    **/
    offsetWidth: number = 0;

    /**
      Posición vertical del botón de desplazamiento hacia abajo.
      @type {number}
    **/
    offsetTopButtonDown: number = 0;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.scrollContainer.nativeElement.addEventListener('wheel', (event: WheelEvent) => {
      this.scrollContainer.nativeElement.scrollTop += event.deltaY * this.scrollSpeed;
      this.updateScrollButtons();
      event.preventDefault();
    });

    this.initShowScroll();
    this.updateScrollButtons();
    // Notificar a Angular que el estado cambió después de la verificación inicial,
    // para evitar NG0100 (ExpressionChangedAfterItHasBeenCheckedError).
    this.cdr.detectChanges();
  }
  /**
    Realiza un desplazamiento en la dirección especificada.
    @param {number} direction - Dirección del desplazamiento (1 para abajo, -1 para arriba).
    @return void
  **/
  scroll(direction: number): void {
    this.scrollContainer.nativeElement.scrollTop += direction * this.scrollSpeed;
    this.scrolled.emit(direction);
    this.updateScrollButtons();
  }
    /**
    Actualiza el estado de los botones de desplazamiento (arriba/abajo) basado en la posición actual del scroll.
    @return void
  **/
  updateScrollButtons() {
    const { scrollTop, scrollHeight, offsetHeight } = this.scrollContainer.nativeElement;

    this.activeUp = scrollTop > 0;

    this.activeDown = scrollTop + offsetHeight < scrollHeight;
  }
 /**
    Inicializa la visibilidad de la barra de desplazamiento y calcula la posición del botón de desplazamiento hacia abajo.
    @return void
  **/
  initShowScroll(){
    const {offsetHeight,scrollHeight, offsetTop} = this.scrollContainer.nativeElement;

    if((offsetHeight < scrollHeight) || this.forceScroll) {

      if(this.paddingRight > 0) {
        this.showScroll = true;
        this.offsetTopButtonDown = (offsetHeight + offsetTop) -38;
      } else {
        this.showScrollPlane = true;
        this.offsetTopButtonDown = 874;
      }

      this.offsetWidth = this.getLeftMargin(this.scrollContainer.nativeElement,0,false) + this.paddingRight;
    }

  }
  /**
    Calcula el margen izquierdo acumulado de un elemento en el DOM.
    @param {HTMLElement} element - Elemento del DOM del cual se calculará el margen.
    @param {number} total - Acumulador del margen izquierdo.
    @param {boolean} parent - Indica si se debe considerar el margen del padre.
    @return {number} Margen izquierdo total.
  **/
  getLeftMargin(element,total:number,parent:boolean){
    const {offsetParent,offsetWidth,offsetLeft} = element;
    total = total + (parent ? 0 : offsetLeft) + (parent ? 0 : (offsetWidth - 0));
    if(offsetParent && offsetParent?.localName != 'body'){
      return this.getLeftMargin(offsetParent,total,true);
    }else{
      return total;
    }
  }

}
